import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login/Login';
import Overview from './pages/Overview/Overview';
import District from './pages/District/District';
import Circuit from './pages/Circuit/Circuit';
import School from './pages/School/School';
import Device from './pages/Device/Device';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Navigate to="/overview" replace /></ProtectedRoute>} />
        <Route path="/overview" element={<ProtectedRoute><Overview /></ProtectedRoute>} />
        <Route path="/district/:slug" element={<ProtectedRoute><District /></ProtectedRoute>} />
        <Route path="/district/:districtSlug/circuit/:circuitSlug" element={<ProtectedRoute><Circuit /></ProtectedRoute>} />
        <Route path="/district/:districtSlug/circuit/:circuitSlug/school/:schoolSlug" element={<ProtectedRoute><School /></ProtectedRoute>} />
        <Route path="/district/:districtSlug/circuit/:circuitSlug/device/:imei" element={<ProtectedRoute><Device /></ProtectedRoute>} />
        <Route path="/district/:districtSlug/circuit/:circuitSlug/school/:schoolSlug/device/:imei" element={<ProtectedRoute><Device /></ProtectedRoute>} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
